export default [
  {
    path: "/springCard",
    component: () => import("@/views/springCard/index"),
    children: [
      {
        path: "home",
        component: () => import("@/views/springCard/home"),
        meta: {
          title: "春城卡专区"
        }
      },
      {
        path: "verify",
        component: () => import("@/views/springCard/verify"),
        meta: {
          title: "春城卡专区"
        }
      },
      {
        path: "protocol",
        component: () => import("@/views/springCard/protocol"),
        meta: {
          title: "春城卡专区"
        }
      },
      {
        path: "signature",
        component: () => import("@/views/springCard/signature"),
        meta: {
          title: "春城卡专区"
        }
      },
      {
        path: "activate",
        component: () => import("@/views/springCard/activate"),
        meta: {
          title: "春城卡专区"
        }
      },
      {
        path: "travel",
        component: () => import("@/views/springCard/travel"),
        meta: {
          title: "畅游长春"
        }
      },
      {
        path: "travelDetail",
        component: () => import("@/views/springCard/travelDetail"),
        meta: {
          title: "景点详情"
        }
      },
      {
        path: "code",
        component: () => import("@/views/springCard/code"),
        meta: {
          title: "身份码"
        }
      },
      {
        path: "selectcode",
        component: () => import("@/views/springCard/selectcode"),
        meta: {
          title: "免费乘车"
        }
      },
      {
        path: "busline",
        component: () => import("@/views/springCard/busline"),
        meta: {
          title: "线路查询"
        }
      },
      {
        path: "miniprogram",
        component: () => import("@/views/springCard/miniprogram"),
        meta: {
          title: "长春旅游"
        }
      },
      {
        path: "benefit",
        component: () => import("@/views/springCard/benefit"),
        meta: {
          title: "春城卡权益"
        }
      },
      {
        path: "benefitPage",
        component: () => import("@/views/springCard/benefitPage"),
        meta: {
          title: "详情"
        }
      }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/router/springCard.js